import './sbrevents1/style';
import FormStructure from './sbrevents1/form_structure';

export default FormStructure;